import type { QuestionDateModelData } from '@coorum-research/shared-common/types/survey-json.type'
import type { SurveyElementForm } from './survey-element-form'
import { useRef, useState } from 'react'
import { cn } from '../../utils'
import { ElementHeader } from './ElementHeader'
import { ElementValidationMessage } from './ElementValidationMessage'
import { commonInputClasses } from './survey-element-styles'
import { SurveyElementLayout } from './SurveyElementLayout'

type Props = {
  currentForm: SurveyElementForm
  validationError: string | null
}

export function SurveyElementDate({
  currentForm,
  validationError,
}: Props) {
  const currentElement = currentForm.elementJson as QuestionDateModelData
  const [value, setValue] = useState(() => currentForm.getValue() as string)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleOnValueChange = (newValue: string) => {
    setValue(newValue)
    currentForm.setElementResultRecordValue(newValue)
  }

  // inputField全体をdatePickerに反応させる
  const openDatePicker = () => {
    inputRef.current?.showPicker()
  }

  // スマホの場合、input type="date"のスタイルが崩れるため、ブラウザ依存のスタイルをリセットする
  // ref: https://zenn.dev/hanri/articles/375f61e0157f0a
  const browserResetClasses = 'appearance-none [-webkit-appearance:none] [-moz-appearance:none]'

  // 値が入力されている場合のみ適用するスタイル
  const filledValueClasses = value
    ? '[&::-webkit-datetime-edit-year-field]:text-current [&::-webkit-datetime-edit-month-field]:text-current [&::-webkit-datetime-edit-day-field]:text-current [&::-webkit-datetime-edit-text]:text-current [color-scheme:light]'
    : ''

  return (
    <SurveyElementLayout>
      <ElementValidationMessage
        validationError={validationError}
      />
      <ElementHeader
        currentElement={currentElement}
      />
      <input
        ref={inputRef}
        type="date"
        className={cn(commonInputClasses, browserResetClasses, filledValueClasses)}
        value={value}
        min={currentElement.min}
        max={currentElement.max}
        placeholder={currentElement.placeholder}
        onChange={e => handleOnValueChange(e.target.value)}
        onClick={openDatePicker}
      />
    </SurveyElementLayout>
  )
}
